import React, { useState } from "react";
import { db } from "../firebase-config"; // Ensure db is correctly initialized
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

function Terms() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    issue: "",
  });

  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Add the issue report to the "reports" collection in Firestore
      await addDoc(collection(db, "reports"), {
        ...formData,
        type: "issue_report", // This helps distinguish the report type if needed
        createdAt: serverTimestamp(), // Adding the timestamp for when the issue is reported
        issueResolved: false, // Add a field to initialize issue as unresolved
      });

      setSubmissionStatus("success");
      setFormData({ name: "", email: "", issue: "" }); // Clear form fields after submission
    } catch (error) {
      console.error("Error reporting issue:", error);
      setSubmissionStatus("error");
    }
  };

  return (
    <div>
      <h1>Terms and Conditions</h1>
      <br />
      <ol>
        <li>A user is eligible for payment if he/she has more than 10 likes</li>
        <li>Payment will vary from Rs10 to Rs100 based on the views of your post</li>
        <li>You can share post to your family, friends and in groups to increase the views</li>
        <li>
          If we found user initiates fake likes then no payment will be forwarded, instead
          his/her account will be blocked
        </li>
      </ol>

      <h2>Report an Issue</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="issue">Issue:</label>
          <textarea
            id="issue"
            name="issue"
            value={formData.issue}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <button type="submit">Submit</button>
      </form>

      {submissionStatus === "success" && (
        <p style={{ color: "green" }}>Your issue has been reported successfully.</p>
      )}
      {submissionStatus === "error" && (
        <p style={{ color: "red" }}>There was an error reporting your issue. Please try again.</p>
      )}
    </div>
  );
}

export default Terms;
